import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { MultiStyleType } from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

import { REFER_BUTTON_CLASS_NAME } from '../ReferButton'
import {
  hiddenRowActionStyle,
  revealedRowActionStyle,
  rowActionRevealSelector,
} from './rowActionReveal'

const transferTargetParts = [
  'container',
  'label',
  'name',
  'button',
  'buttonText',
] as const

const helpers = createMultiStyleConfigHelpers(transferTargetParts)

export const TransferTargetStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      height: '62px',
      width: 'full',
      paddingY: '12px',
      paddingX: '20px',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: '8px',
      backgroundColor: 'transparent',
      position: 'relative',
      _hover: {
        backgroundColor: 'bg.muted',
      },
      _focusWithin: {
        backgroundColor: 'bg.muted',
      },
      [rowActionRevealSelector(REFER_BUTTON_CLASS_NAME)]:
        revealedRowActionStyle,
    },
    label: {
      display: 'inline-flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      minWidth: 0,
    },
    name: {
      display: 'inline-flex',
      maxHeight: '24px',
      alignSelf: 'center',
      paddingX: '12px',
      minWidth: 0,
      color: 'fg.default',
      ...textStyles[textStyleKeys.Body1],
    },
    button: {
      height: '38px',
      paddingY: '10px',
      paddingX: '18px',
      backgroundColor: 'blue.solid',
      borderRadius: '100px',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      flexShrink: 0,
      ...hiddenRowActionStyle,
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'brand.fg',
        outlineOffset: '2px',
      },
    },
    buttonText: {
      ...textStyles[textStyleKeys.Body2_Semibold],
      textWrap: 'nowrap',
      color: 'fg.inverted',
    },
  },
  defaultProps: {},
})

export const useTransferTargetStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(TransferTargetStyle, props) as MultiStyleType<
    typeof transferTargetParts
  >
}
